import Reveal from "./Reveal";

const TESTIMONIALS = [
  {
    quote:
      "Reliable sourcing across multiple categories. B&S delivered consistent quality on our private label bags order.",
    name: "James Mitchell",
    company: "Harbor Retail Group",
    country: "🇬🇧 United Kingdom",
  },
  {
    quote:
      "Their pre-shipment inspection reports gave us full confidence. On-time delivery to Jebel Ali port as promised.",
    name: "Fatima Al-Rashid",
    company: "Gulf Wholesale Trading",
    country: "🇦🇪 UAE",
  },
  {
    quote:
      "Flexible MOQs helped us test new jewellery lines before scaling. Professional team from inquiry to export docs.",
    name: "David Chen",
    company: "Pacific Import Co.",
    country: "🇸🇬 Singapore",
  },
];

export default function Testimonials() {
  return (
    <section className="section-shell bg-surface-alt/50">
      <div className="section-inner">
        <Reveal>
          <div className="text-center mb-8">
            <p className="label-cap text-accent mb-2">Trusted Worldwide</p>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-primary">What Buyers Say</h2>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 100}>
              <blockquote className="h-full bg-surface border border-border rounded-2xl p-6 md:p-8">
                <p className="text-sm text-muted leading-relaxed italic">&ldquo;{t.quote}&rdquo;</p>
                <footer className="mt-6 pt-4 border-t border-border">
                  <div className="font-semibold text-primary text-sm">{t.name}</div>
                  <div className="text-xs text-muted mt-1">{t.company}</div>
                  <div className="text-xs text-muted mt-1">{t.country}</div>
                </footer>
              </blockquote>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
